import { ScanChartWrapper } from "../../components";
import AuthService from "../../utilities/services/auth.service";

export default function ScanChartPage() {
  const organization = AuthService.getOrg()[0];

  return <ScanChartWrapper organization={organization} />;
}
